// Libs
import * as _ from 'lodash';

//Constants
import * as ACTIONS from './constants';

//Types
//import { Dealer } from './types';
import * as types from './types';
import { IAction } from '@state/types';

const defaultState: types.IDealerState = {
    dealers: undefined,
    page: 0,
    query: "",
    limit: ACTIONS.DEFAULT_PAGE_SIZE,
    error:false,
    loading:true,
};

function dealerReducer(state: types.IDealerState = defaultState, action: IAction): types.IDealerState {
    switch (action.type) {

        case ACTIONS.GET_DEALER_API_REQUEST:
            {
                return{
                    ...state,
                    loading:true
                }
            }
        case ACTIONS.GET_DEALER_API_SUCCESS:
            {
                const { page } = (action as types.ActionGetDealerApiSuccess)
                const apiDealers = (action as types.ActionGetDealerApiSuccess).dealers
                const { dealers } = state;
                let flattenedDealers = dealers;
                //State dealers is an array of arrays, it should be flattened as and array of Dealers
                if(dealers && dealers.length > 0) {
                    if(Array.isArray(dealers[0])) {
                        flattenedDealers = dealers[0];
                    }
                }
                const newDealers = _.uniqBy([...(flattenedDealers ?? []), ...apiDealers], 'id');
                return {
                    ...state,
                    dealers: newDealers,
                    page: page || 0,
                    lastPageSize: apiDealers?.length,
                    error:false,
                    loading:false,
                    
                }
            }
        case ACTIONS.GET_DEALER_BY_ID_API_SUCCESS:
            {
                const { dealer } = (action as types.ActionGetDealerByIdSuccess)
                const newDealers = _.uniqBy([...(state.dealers ?? []), ...[dealer]], 'id');
                return {
                    ...state,
                    dealers: newDealers,
                    error:false,
                    loading:false
                }
            }
        case ACTIONS.DEALERS_LOAD_MORE: {
            return {
                ...state,
                page: state.page + 1,
                loading:true
            }
        }
        case ACTIONS.EDIT_DEALER_SEARCH_QUERY: {
            const { query } = action as types.ActionEditDealerSearchQuery;
            return {
                ...state,
                dealers: query === state.query ? state.dealers : [],
                page: 0,            
                query,
                error:false
            }
        }
        case ACTIONS.EDIT_SELECTED_DEALER: {
            const { dealer } = action as types.ActionEditSelectedDealer;
            return {
                ...state,
                selectedDealer: dealer,
                error:false
            }
        }
        case ACTIONS.GET_DEALER_BY_ID_API_ERROR:{
            return{
                ...state,
                error:true
            }

        }
        case ACTIONS.SET_DEALER_COLLECTIONS: {
            const { collectionsResponse } = action as types.ISetCollectionsAction;
            return { ...state, collections: collectionsResponse }
        }
        case ACTIONS.SET_DEALER_ASSETS: {
            const { assetsResponse } = action as types.ISetAssetsAction;
            return { ...state, assets: assetsResponse }
        }
        case ACTIONS.SET_DEALER_ASSETS_NAMES: {
            const { response } = action as types.ISetAssetsNamesAction;
            return { ...state, assetsNames: response.names, assetsUrls: response.url }
        }
    }
    return {
        ...state
    }
}

export default dealerReducer;